import classnames from 'classnames';
import Link       from '../components/link';
import React      from 'react';


//  Primary button is a wide button
//
//  label     - Button label
//  href      - Navigate to this URL (<a>)
//  onClick   - Event handler (</button>)
//  danger    - Use red color
//  fill      - If this is false it will only have borders
export default function PrimaryButton({ label, href, onClick, className = '', disabled = false, external = false, fill = true, danger = false }) {
  const buttonClassName = classnames('button', className, { external, danger, 'button-fill': fill });
  return (
    <p className="buttons-row">
      {href ? (
        <Link href={href} className={buttonClassName} external={external}>{label}</Link>
      ) : (
        <button onClick={onClick} className={buttonClassName} disabled={disabled}>{label}</button>
      )}
    </p>
  );
}
